import { ReactNode } from "react";

type AdminPanelHeaderProps = {
  action?: ReactNode;
  className?: string;
  description: ReactNode;
  icon: ReactNode;
  title: ReactNode;
};

function joinClassNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function AdminPanelHeader({
  action,
  className,
  description,
  icon,
  title,
}: AdminPanelHeaderProps) {
  return (
    <div className={joinClassNames("admin-users-hero", className)}>
      <div className="admin-users-hero-copy">
        <span className="admin-users-hero-icon" aria-hidden="true">
          {icon}
        </span>
        <div>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
      {action}
    </div>
  );
}
